import axiosInstance from '../../helpers/axiosInstance'

export default function getCamposRequeridosPorSistemaService (sistema) {
    return axiosInstance.get('campos/'+sistema)
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}
